import Keycloak from 'keycloak-js';
import { env } from '@/config/env';

let instance: Keycloak | null = null;
let initPromise: Promise<boolean> | null = null;

/** Singleton keycloak-js do SPA — não chame `new Keycloak()` em outro lugar. */
export function getKeycloak(): Keycloak {
  if (!instance) {
    const { url, realm, clientId } = env.keycloak;
    const keycloak = new Keycloak({ url, realm, clientId });
    // Renova o access token quando ele expira; se o refresh falhar (sessão SSO
    // encerrada no servidor), volta pro login do Keycloak.
    keycloak.onTokenExpired = () => {
      void keycloak.updateToken(30).catch(() => triggerKeycloakLogin());
    };
    instance = keycloak;
  }
  return instance;
}

/**
 * Roda `keycloak.init` no máximo uma vez por page load.
 * Seguro sob React StrictMode (montagem dupla) — a segunda montagem espera a
 * mesma promise.
 */
export function ensureKeycloakInitialized(): Promise<boolean> {
  const keycloak = getKeycloak();
  if (!initPromise) {
    initPromise = keycloak.init({
      onLoad: 'check-sso',
      pkceMethod: 'S256',
      checkLoginIframe: false,
      silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
      // `organization:*` traz TODAS as organizations do usuário na claim
      // `organization` — é ela que a API casa com tenants.slug. Com o usuário
      // em uma única organization o Keycloak inclui a claim sozinho, mas a
      // partir de duas ele exige o pedido explícito (26.x): sem isto a claim
      // some e a API responde 403 por não achar tenant.
      scope: 'organization:*',
    });
  }
  return initPromise;
}

// O provider de token e o handler de 401 podem decidir reautenticar ao mesmo
// tempo — N queries paralelas falhando chamariam `keycloak.login()` N vezes,
// disparando N mudanças de location (loop de reload). O guard garante uma só.
let loginInFlight = false;

/** Redireciona pra página de login (temada) do Keycloak — no máximo uma vez. */
export function triggerKeycloakLogin(): void {
  if (loginInFlight) return;
  loginInFlight = true;
  void getKeycloak().login({ redirectUri: `${window.location.origin}/` });
}

/** Libera o guard de login (remount do gate: StrictMode/HMR). */
export function resetLoginInFlight(): void {
  loginInFlight = false;
}
